import { browser } from '@openclassrooms/utils';

export default function isFromHomePage(path) {
  const locationOrigin = browser.window.location.origin;
  return (
    path === `${locationOrigin}/fr/` ||
    path === `${locationOrigin}/en/` ||
    path === '/fr/' ||
    path === '/en/'
  );
}
